/** Version of this client bundle (`client/package.json`), injected by Vite's `define`. */
export const BUNDLE_VERSION: string | null =
    typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : null;
